export default function (state, val) {
    let data = [];
    let items = val.Items;

    items.forEach(i => {
        let item = data.filter(j => {
            return j.currency === i.PaymentCurrencyId;
        })[0];
        if (!item) {
            data.push({
                currency: i.PaymentCurrencyId,
                payed: i.Payed,
                amount: 1,
                needToPay: i.NeedToPay,
                paymentSum: i.PaymentSum,
                overPayments: (i.Payed - i.PaymentSum) > 0 ? (i.Payed - i.PaymentSum) : 0,
                // underpayment: (i.PaymentSum - i.Payed) > 0 ? (i.PaymentSum - i.Payed) : 0,
            });
        } else {
            item.amount++;
            item.payed += i.Payed;
            item.needToPay += i.NeedToPay;
            item.paymentSum += i.PaymentSum;
            item.overPayments += (i.Payed - i.PaymentSum) > 0 ? (i.Payed - i.PaymentSum) : 0;
            // item.underpayment += (i.PaymentSum - i.Payed) > 0 ? (i.PaymentSum - i.Payed) : 0;
        }
    });
    state.items = data;
}